export var ActionButtonType;
(function (ActionButtonType) {
    ActionButtonType[ActionButtonType["toggle"] = 0] = "toggle";
    ActionButtonType[ActionButtonType["pop"] = 1] = "pop";
    ActionButtonType[ActionButtonType["close"] = 2] = "close";
    ActionButtonType[ActionButtonType["control"] = 3] = "control";
})(ActionButtonType || (ActionButtonType = {}));
